/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type the text shown above`)
};

const es_typing_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe el texto que se muestra arriba`)
};

const de_typing_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe den oben angezeigten Text`)
};

const nl_typing_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ de hierboven getoonde tekst`)
};

const fr_typing_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez le texte affiché ci-dessus`)
};

const it_typing_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digita il testo mostrato sopra`)
};

const pt_br2_typing_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite o texto mostrado acima`)
};

const pt_typing_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escreva o texto apresentado acima`)
};

const ja_typing_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上に表示されたテキストを入力してください`)
};

const zh_typing_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入上方显示的文本`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_input_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_input_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_input_label", locale)
	if (locale === "en") return en_typing_input_label(inputs)
	if (locale === "es") return es_typing_input_label(inputs)
	if (locale === "de") return de_typing_input_label(inputs)
	if (locale === "nl") return nl_typing_input_label(inputs)
	if (locale === "fr") return fr_typing_input_label(inputs)
	if (locale === "it") return it_typing_input_label(inputs)
	if (locale === "pt-BR") return pt_br2_typing_input_label(inputs)
	if (locale === "pt") return pt_typing_input_label(inputs)
	if (locale === "ja") return ja_typing_input_label(inputs)
	return zh_typing_input_label(inputs)
};